import { request } from './http'
import type { PulseSummary } from '@/types/pulse'

export const pulseApi = {
  summary: (): Promise<PulseSummary> => request<PulseSummary>('/v1/pulse/summary'),
}
